import PropTypes from 'prop-types';
import { handleStopPropagation } from 'consts';
import { Menu } from '@material-ui/core';
import { selector } from 'selectors/viewAs';
import { useSelector } from 'react-redux';
import Product from './Product';

const anchorOrigin = { horizontal: 'left', vertical: 'center' };
const transformOrigin = { horizontal: 'right', vertical: 'center' };

const Products = ({
  anchorEl,
  onClose,
  onExited,
  onProductSelect,
  payerId,
  palRefreshEnabled,
  submenu,
}) => {
  const { urls = [] } = useSelector((_) => selector(_, payerId)) ?? {};

  return urls.length > 1 ? (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={submenu ? anchorOrigin : undefined}
      getContentAnchorEl={null}
      onClick={handleStopPropagation}
      onClose={onClose}
      open={Boolean(anchorEl)}
      transformOrigin={submenu ? transformOrigin : undefined}
      TransitionProps={{ onExited }}
    >
      {urls.map(({ id, name, url }) => (
        <Product
          id={id}
          key={id}
          name={name}
          onClick={onClose}
          onSelect={onProductSelect}
          palRefreshEnabled={palRefreshEnabled}
          url={url}
        />
      ))}
    </Menu>
  ) : null;
};

Products.propTypes = {
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onExited: PropTypes.func,
  onProductSelect: PropTypes.func,
  payerId: PropTypes.number.isRequired,
  palRefreshEnabled: PropTypes.bool,
  submenu: PropTypes.bool,
};

Products.defaultProps = {
  anchorEl: null,
  onExited: undefined,
  onProductSelect: undefined,
  palRefreshEnabled: false,
  submenu: false,
};

export default Products;
